var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BField",
    {
      attrs: {
        label: _vm.label,
        "label-for": _vm.id,
        message: _vm.message,
        type: { "is-danger": !_vm.valid },
        "custom-class": _vm.customClass
      }
    },
    [
      _c("BInput", {
        attrs: {
          id: _vm.id,
          name: _vm.name,
          type: "password",
          icon: "lock",
          minlength: "8",
          maxlength: "50",
          placeholder: "Contraseña123",
          value: _vm.value,
          loading: _vm.loading,
          required: _vm.required,
          disabled: _vm.disabled,
          pattern: _vm.pattern,
          "has-counter": false,
          "password-reveal": ""
        },
        on: {
          focus: _vm.onFocus,
          input: _vm.onChange,
          change: _vm.onChange,
          blur: _vm.onBlur
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }